import { useQuery } from "@tanstack/react-query";

import { CUSTOMER_QUERY_KEYS } from "common/constants";
import { useAuth } from "common/context/AuthContext";

import { get } from "../helpers/HTTP";

import type { Workspace } from "../types";

async function getWorkspacesRequest(): Promise<Workspace[]> {
  return (await get(`workspaces`)).workspaces;
}

export default function useWorkspaces() {
  const { isAuthorized } = useAuth();

  const { data: workspaces, refetch: refetchWorkspaces } = useQuery({
    queryKey: CUSTOMER_QUERY_KEYS.workspaces.base,
    queryFn: getWorkspacesRequest,
    refetchOnMount: false,
    enabled: !!isAuthorized,
  });

  return {
    workspaces,
    refetchWorkspaces,
  };
}
